import {
  MediaActionType,
  MediaAudioCancelIcon,
  MediaAudioCancelReceivedIcon,
  MediaVideoCancelIcon,
  MediaVideoCancelReceivedIcon,
  MediaAudioCallIcon,
  MediaVideoCallIcon,
} from '@halo/ui-chat-react';
import { Center } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import { MsgPayloadType } from '@halo/chat-sdk';

function IconWrapper({ isError, children }: { isError?: boolean; children: ReactNode }) {
  return (
    <Center
      w="11"
      h="11"
      bg="white"
      fontSize="3xl"
      color={isError ? 'fg.error' : 'fg.subtle'}
      borderRadius="full"
    >
      {children}
    </Center>
  );
}

export function ActionMediaIcon({
  payload_type,
  type,
  isMe,
}: {
  payload_type: MsgPayloadType;
  type: MediaActionType;
  isMe?: boolean;
}) {
  switch (payload_type) {
    case MsgPayloadType.GROUP_MEDIA_CLOSE: {
      return (
        <IconWrapper isError={false}>
          {type === MediaActionType.AUDIO ? <MediaAudioCallIcon /> : <MediaVideoCallIcon />}
        </IconWrapper>
      );
    }
    case MsgPayloadType.CALL_HANG_UP:
    case MsgPayloadType.CALL_CANCELLED:
    case MsgPayloadType.CALL_REJECTED: {
      return isMe ? (
        <IconWrapper isError={false}>
          {type === MediaActionType.AUDIO ? <MediaAudioCancelIcon /> : <MediaVideoCancelIcon />}
        </IconWrapper>
      ) : (
        <IconWrapper isError={false}>
          {type === MediaActionType.AUDIO ? (
            <MediaAudioCancelReceivedIcon />
          ) : (
            <MediaVideoCancelReceivedIcon />
          )}
        </IconWrapper>
      );
    }
    case MsgPayloadType.CALL_TIMEOUT:
    case MsgPayloadType.CALL_NETWORK_ERROR: {
      return isMe ? (
        <IconWrapper isError={true}>
          {type === MediaActionType.AUDIO ? <MediaAudioCancelIcon /> : <MediaVideoCancelIcon />}
        </IconWrapper>
      ) : (
        <IconWrapper isError={true}>
          {type === MediaActionType.AUDIO ? (
            <MediaAudioCancelReceivedIcon />
          ) : (
            <MediaVideoCancelReceivedIcon />
          )}
        </IconWrapper>
      );
    }
  }
}
